import { ExamTable } from './ExamTable';
export default ExamTable;
